export const breadcrumbData = (salesChannelName, uuid, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: '',
    name: salesChannelName,
  },
  {
    url: `/salesChannel/settings/${uuid}`,
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('salesChannelInventory.index.inventory'),
  },
];
